// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"page_mainDiv__yhvwy","labelsDiv":"page_labelsDiv__O1Tmy","mainBox":"page_mainBox__zktqH","insideBox":"page_insideBox__pJYc1"};